<template>
  <div id="app" class="container-fluid">
    <div id="header" class="row">
        <div class="roboto-style container">
          <b-navbar toggleable="lg" class="bg-white" fixed="top" type="light">
            <dots v-if="width >= 768"></dots>
            <dots_xs v-if="width<768"></dots_xs>
            <div class="container" v-bind:style="width >=1023 && width <=1027 ? 'padding:0' : ''">
                <router-link class="navbar-brand p-0" to="/">
                  <logo></logo>
                </router-link>
                  <b-navbar-toggle target="nav-collapse" class="float-right"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                  <li class="nav-link links"><router-link active-class="active" to="services">Services</router-link></li>
                  <li class="nav-link links"><router-link active-class="active" to="clients">Clients</router-link></li>
                  <li class="nav-link links"><router-link active-class="active" to="company">Company</router-link></li>
                  <li class="nav-link links"><router-link active-class="active" to="get-in-touch">Get in touch</router-link></li>
                  <li class="nav-link">
                      <router-link class="greybtn button medium-grey" to="start-a-project">
                        Start a project
                        <arrow></arrow>
                      </router-link>
                  </li>
              </b-navbar-nav>
            </b-collapse>
            </div>
          </b-navbar>
        </div>
    </div>

    <router-view></router-view>

    <div class="footer row black-container">
      <a class="position-absolute row container-fluid" href="#" style="max-height: 30px">
        <dotfooter></dotfooter>
      </a>
        <div class="container xs_margint" v-bind:style="width>768?'padding-top:75px':''">
          <div class="row">
            <div class="col-md-6">
              <logo_footer></logo_footer>
              <div class="row">
                <p class="col-md-6 roboto-style greentxt">We apply our talents and expertise from various industries to bring your idea to life and make your business more profitable.</p>
              </div>
            </div>
            <div class="col-md-6 mt-3">
              <div class="row xs-descr inter-style">
                <div class="col-lg-4 col-md-6 col-6 px-lg-3 pb-3">
                    <router-link class="white d-block mb-3" to="services">Services</router-link>
                    <router-link class="white d-block mb-3" to="clients">Clients</router-link>
                    <router-link class="white d-block mb-3" to="company">Company</router-link>
                    <router-link class="white d-block mb-3" to="get-in-touch">Get in touch</router-link>
                    <router-link class="white d-block font-weight-bold" to="start-a-project">
                      Start a project
                    </router-link>
                </div>
                <div class="col-lg-4 col-md-6 col-6 pr-0">
                  <a target="_blank" href="https://www.facebook.com/dev51.io/" class="white d-block mb-3">Facebook</a>
                  <a target="_blank" href="https://www.linkedin.com/company/unknownsoftware/" class="white d-block mb-3">LinkedIn</a>
                  <a target="_blank" href="https://www.instagram.com/dev.51/" class="white d-block mb-3">Instagram</a>
                </div>
                <div class="col-lg-4 col-md-12 p-lg-0 py-md-4 mt-4 mt-md-0">
                  <div v-bind:class="['row mb-1', {'mx-0' : width >=768 && width <1024}]"><div class="col-md-1 pl-lg-1 col-1 pl-md-0"><location></location></div><p class="col-md-10 col-10 light-grey pl-lg-2 pl-sm-0">340 S Lemon Ave, Walnut CA 91789</p></div>
                  <div v-bind:class="['row mb-1', {'mx-0' : width >=768 && width <1024}]"><div class="col-md-1 pl-lg-1 col-1 pl-md-0"><phone></phone></div><p class="col-md-10 col-10 light-grey pl-lg-2 pl-sm-0">(650) 614.56.44</p></div>
                  <div v-bind:class="['row mb-1', {'mx-0' : width >=768 && width <1024}]"><div class="col-md-1 pl-lg-1 col-1 pl-md-0"><email></email></div><div class=""></div><p class="col-10 col-md-10 col-sm-4 light-grey pl-lg-2 pl-sm-0" style="word-break: break-all;">hello@unknown.software</p></div>
                </div>
              </div>
            </div>
      </div>
          <div v-bind:class="['row medium-grey inter-style smallsize-txt', {'pb-5' : width > 1025}]"><p class="col-md-6 xs_marginb">©2019 Unknown Software  <!--·  <u>Terms & Conditions</u>  ·  <u>Privacy Policy</u> --></p></div>
      </div>
    </div>
    <div v-if="privacyModal&&!closemodal" class="row white position-fixed roboto-style privacyModal">
      <div class="col-lg-3 col-md-6 col-8 offset-4 offset-md-6 offset-lg-9">
        <div class="row pt-3">
          <div class="col-md-12 col-12"><p>Cookies and IP addresses allow us to deliver and improve our web content, resolve technical errors, and provide you with a personalized experience. Our website uses cookies and collects your IP address for these purposes.</p></div>
          <div class="col-md-12 col-12">
            <p>Unknown Software may use cookies and my IP address to
              collect individual statistics and to provide me with
              personalized offers and ads subject to the Privacy
              Policy and the Terms of Use. Unknown Software may use
              third-party services for this purpose. I can revoke
              my consent at any time by visiting the Opt-Out page.</p>
            <a class="mr-3 green" @click="closePrivacy(1)">[Y]es, I agree</a>
            <a class="green" @click="closePrivacy(0)">[N]o, thanks</a>
          </div>
          <div class="col-md-12 pt-3"><p>>?</p></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from './components/logo';
import Arrow from './components/arrow';
import FooterSvg from './components/footersvg';
import dots from './components/dots';
import greendots from './components/greendots';
import location from './components/location';
import phone from './components/phone';
import email from './components/email';
import logoxs from './components/logo_xs';
import logo_footer from './components/logo_footer';
import dotfooter from './components/dotfooter';
import dots_xs from './components/dots_xs';
export default {
  name: 'app',
  components: {
      Logo: Logo,
      Arrow: Arrow,
      FooterSvg: FooterSvg,
      dots: dots,
      greendots: greendots,
      phone: phone,
      email: email,
      location: location,
      logoxs,
      logo_footer,
      dotfooter,
      dots_xs
  },
    mounted() {
      window.addEventListener("scroll", function () {
          if(document.documentElement.scrollTop >= 10) {
              document.getElementById("header").classList.add("scrollHeader");
          } else {
              document.getElementById("header").classList.remove("scrollHeader");
          }
      });
        this.width = window.innerWidth;
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
    },
    computed: {
      privacyModal() {
          const cookie = this.$cookies.get('modal_shown');
          if (cookie == null) {
              return true;
          } else {
              return false;
          }
        },
        windowWidth: {
            get: function () {
                return this.width;
            },
            set: function (val) {
                this.width = val;
            }

        }
    },
    data() {
      return {
        closemodal : false,
          width: 0
      }
    },
    methods: {
      closePrivacy(nr) {
          const cookie = this.$cookies.get('modal_shown');
          if (cookie == null) {
              this.$cookies.set('modal_shown', nr == 1 ?'yes':'no');
              this.closemodal = true;
          }
      }
    }
}
</script>

<style lang="scss">
@import "./style/style.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue